export default "__VITE_ASSET__Cv1L0tZ___"